import React from "react";
import InternalStudyStudentsService from "@services/internal-study-students-service";
import toast from "react-hot-toast";
import { TextField } from "@mui/material";
import clsx from "clsx";
import style from "@scss/modals/company/create-company.module.scss";
import useModal from "@modals/modal-hook";
import useStyles from "@ui/material-ui-styles";

const EditInternalStudentModal = () => {
  const { close, modalComponent, modalData } = useModal();
  const classes = useStyles();

  const handleSubmit = async (e: React.SubmitEvent<HTMLFormElement>) => {
    e.preventDefault();
    const modalBtn = document.querySelector("button.modal_btn") as HTMLButtonElement;
    modalBtn.disabled = true;

    const password = document.querySelector('input[name="password"]') as HTMLInputElement;

    return InternalStudyStudentsService.update(
      modalData.id,
      { password: password?.value },
      (err, res) => {
        if (err || !res) {
          if (err?.response?.status === 422) {
            modalBtn.disabled = false;
          }
          toast.error(`Ошибка при обновлении обучающегося "${modalData.title}"`);
        }

        close();
      }
    );
  };

  return (
    <div key={modalComponent.key} className={clsx(style.create_company_modal)}>
      <p className="modal_title">
        Редактировать пароль обучающегося "{modalData.title}"
      </p>
      <div className="underline" />
      <form className={`modal_content ${classes.root}`} onSubmit={handleSubmit}>
        <TextField
          name="password"
          label="Пароль"
          variant="filled"
          required
          type="password"
          autoComplete="off"
          slotProps={{
            input: {
              autoComplete: "off",
            },
          }}
        />
        <button type="submit" className="modal_btn">
          {modalComponent.btnText}
        </button>
      </form>
    </div>
  );
};

export default EditInternalStudentModal;
